import angular from 'angular';
import uiRouter from 'angular-ui-router';
import employeeComponent from './employee.component';

let employeeModule = angular.module('employee', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newEmployee', {
            url: '/employees/new',
            component: 'employee',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editEmployee', {
            url: '/employees/:id',
            component: 'employee',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                employee: (EmployeesService, $stateParams) => {
                    return EmployeesService.findById($stateParams.id, {
                        include: ['segaUser']
                    });
                }
            }
        });
})
.component('employee', employeeComponent)
.name;

export default employeeModule;
